export const namespace = 'settings';

export const MutationTypes = {
  SET_SETTINGS: 'SET_SETTINGS',
};

export const ActionTypes = {
  GET_SETTINGS: 'GET_SETTINGS',
};
